import { Chart, Tooltip, registerables as defaultRegisterables } from 'chart.js';

import { colors } from '@optical/utils';

/**
 * Register Chart.js plugins
 */
Chart.register(...defaultRegisterables);
Chart.register(Tooltip);

/**
 * Global Chart.js config
 */
Chart.defaults.borderColor = colors.gray['200'];
Chart.defaults.color = colors.gray['500'];
Chart.defaults.font.family = 'var(--font-sans)';
Chart.defaults.plugins.tooltip.backgroundColor = colors.gray['800'];
Chart.defaults.plugins.tooltip.bodySpacing = 4;
Chart.defaults.plugins.tooltip.boxPadding = 4;
Chart.defaults.plugins.tooltip.cornerRadius = 8;
Chart.defaults.plugins.tooltip.footerMarginTop = 8;
Chart.defaults.plugins.tooltip.padding = 8;
Chart.defaults.plugins.tooltip.titleMarginBottom = 8;
Chart.defaults.plugins.tooltip.titleFont = {
  size: 14,
  weight: 600,
  family: 'var(--font-title)',
};
